// extracted by mini-css-extract-plugin
module.exports = {"productSliderWrapper":"ProductsSlider_productSliderWrapper__pJvaL"};